/** Runtime config from Vite env. OIDC is optional: when the `orkestor-web`
    Keycloak client is not yet provisioned, leave these unset and the app falls
    back to the dev-stub auth (see auth.tsx). */
export interface OidcConfig {
  authority: string;
  clientId: string;
}

export function readOidcConfig(): OidcConfig | null {
  const env = import.meta.env;
  const authority = env["VITE_OIDC_AUTHORITY"] as string | undefined;
  const clientId = env["VITE_OIDC_CLIENT_ID"] as string | undefined;
  if (!authority || !clientId) return null;
  return { authority, clientId };
}

/** Centrifugo WebSocket endpoint (e.g. wss://ws.orkestor.com/connection/websocket).
    Unset → realtime is disabled and the console relies on polling alone. */
export function readRealtimeUrl(): string | null {
  const url = import.meta.env["VITE_REALTIME_URL"] as string | undefined;
  return url && url.length > 0 ? url : null;
}
